import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import ReviewsAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/ReviewsAppIcon';

import Spacer20 from '../../../Misc/Spacer20.js';
import ReviewsAppEnabledDialog from '../../Reviews/ReviewsAppEnabledDialog';

const ReviewsStrategy = {
  previewInfo: {
    name: 'Reviews',
    newTab: true,
    iconSvg: <ReviewsAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Reviews',
    category: 'Online Review Generation',
    details: (
      <div>
        Get feedback from customers after their job is complete. It’s a great way to improve your service and develop
        testimonials for jobs well done.
        <Spacer20 />
        When a job is marked as finished, your customer will automatically receive an email and a text message asking
        for a review. You can exclude customers based on customer or job tags and hook up your Google My Business
        account in the app settings. Once you turn it on, just click on Reviews from the &apos;My Apps&apos; tab and
        then on the settings gear.
      </div>
    ),
    iconSvg: <ReviewsAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/fx90atwebh?autoPlay=false',
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Premium Reviews Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Premium Reviews Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideCard: true,
  },
  supportContacts: [],
  dialog: <ReviewsAppEnabledDialog />,
};

export default ReviewsStrategy;
